<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  aparatLink: {
    type: String,
    required: true
  }
})
</script>

<template>
  <div class="videoWrapper hiframe-aparatembedframe">
    <span style="display: block; padding-top: 57%"></span>
    <iframe
      scrolling="no"
      allowFullScreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      :src="aparatLink"
    ></iframe>
  </div>
</template>

<style lang="scss" scoped>
.videoWrapper {
  position: relative;
  height: unset
}

.videoWrapper iframe {
  border-radius: 26px;
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
